import moment from 'moment'
import { _Object } from './interfaces';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faRightLeft, faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons';

export const getAcronym = (inputString: string) => {
  if (inputString) {
    const words = inputString?.split(' ');
    const acronym = words.map(word => word.charAt(0).toUpperCase()).join('');
    return acronym;
  }
};

export const showTostify = (ref: any, type: any, message: string) => {
  if (type === 'success') {
    ref.current?.show({ severity: 'success', summary: 'Success', detail: message || 'Login successful!', life: 4000 });
  } else {
    ref.current?.show({ severity: 'error', summary: 'Error', detail: message || 'Login failed', life: 3000 });
  }
}

export const generateQueryParams = (args: any) => {
  let str = ''
  let replace = ''
  for (const key in args) {
    if (typeof (args[key]) === 'object') {
      for (const key1 in args[key]) {
        str += `&filters[${key1}]=${args[key][key1]}`
        replace = str.slice(1)
      }
    } else {
      str += `&${key}=${args[key]}`
      replace = str.slice(1)
    }
  }
  return replace
}

// export const formatDate: any = (date: string) => {
//   return moment(date).format('MM/DD/YYYY')
// }

export const formatDate = (date: string) => {
  return moment(date).format('MMMM D, YYYY');
};


export function formatPhoneNumber(phoneNumber: string) {
  // Ensure the phone number is clean and properly formatted
  const cleanedNumber = phoneNumber.replace(/\D/g, ''); // Remove non-digit characters
  if (cleanedNumber.length === 12) {
    return `+91 ${cleanedNumber.slice(0, 5)} ${cleanedNumber.slice(5)}`; // Format as "+91 XXXXX XXXXX"
  }
  return phoneNumber; // Return original if not 10 digits
}

export const handleFilters = (key: string, value: any, setState: any) => {
  if (key === 'filters') {
    setState((pre: _Object) => ({
      ...pre,
      filters: {
        ...pre.filters,
        [value?.key]: Array.isArray(value?.value) ? value?.value?.map((data: { [key: string]: string }) => { return data.value }) || '' : value?.value?.value || ''
      }
    }))
  } else {
    setState((pre: _Object) => ({
      ...pre,
      page: 1,
      [key]: value
    }))
  }
}

export const getSortIcon = (sortKey: string) => {
  if (!sortKey) return "pi-arrows-v"
  if (sortKey.includes('-')) return "pi-arrow-down"
  if (!sortKey.includes('-')) return "pi-arrow-up"
}

export const capitalizeFirstLetter = (name = '') => {
  const firstLetter = name?.length > 0 ? name?.charAt(0).toUpperCase() : ''
  const restOfName = name?.length > 0 ? name?.slice(1).toLowerCase() : ''
  const capitalizedUserName = firstLetter + restOfName
  return capitalizedUserName;
};

// Helper function to generate image preview URL
export const generatePreviewUrl = (file: File): string => {
  if (file instanceof File) {
    return URL.createObjectURL(file);
  } else {
    console.error("Invalid file object:", file);
    return ""; // Fallback, should not happen if files are correct
  }
};